import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { FaShoppingCart, FaThLarge, FaUser } from 'react-icons/fa';
import { useCart } from '../contexts/CartContext';
import { useAuth } from '../contexts/AuthContext';

const MenuWrapper = styled.nav`
  display: none;
  
  @media (max-width: 768px) {
    display: flex;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 60px;
    background: white;
    box-shadow: 0 -2px 15px rgba(0, 0, 0, 0.1);
    z-index: 999;
    padding-bottom: env(safe-area-inset-bottom, 0);
  }
`;

const MenuInner = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: space-around;
  align-items: center;
  max-width: 500px;
  margin: 0 auto;
`;

const MenuItem = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  height: 100%;
  text-decoration: none;
  color: ${props => props.$active ? '#ff6b35' : '#666'};
  transition: color 0.2s ease;
  
  &:active {
    background: rgba(255, 107, 53, 0.05);
  }
`;

const MenuIcon = styled.div`
  font-size: 22px;
  margin-bottom: 2px;
  position: relative;
`;

const MenuLabel = styled.span`
  font-size: 11px;
  font-weight: 500;
`;

const CartBadge = styled.span`
  position: absolute;
  top: -6px;
  right: -10px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  background: #ff6b35;
  color: white;
  font-size: 10px;
  font-weight: 700;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const MobileBottomMenu = () => {
  const location = useLocation();
  const { totalItems } = useCart();
  const { isAuthenticated } = useAuth();

  const isActive = (path) => {
    if (path === '/catalog') {
      return location.pathname === '/catalog' || location.pathname.startsWith('/catalog/');
    }
    if (path === '/profile') {
      return location.pathname === '/profile' || location.pathname.startsWith('/dashboard');
    }
    return location.pathname === path;
  };

  return (
    <MenuWrapper>
      <MenuInner>
        <MenuItem to="/cart" $active={isActive('/cart')}>
          <MenuIcon>
            <FaShoppingCart />
            {totalItems > 0 && <CartBadge>{totalItems > 99 ? '99+' : totalItems}</CartBadge>}
          </MenuIcon>
          <MenuLabel>Корзина</MenuLabel>
        </MenuItem>
        
        <MenuItem to="/catalog" $active={isActive('/catalog')}>
          <MenuIcon>
            <FaThLarge />
          </MenuIcon>
          <MenuLabel>Каталог</MenuLabel>
        </MenuItem>
        
        <MenuItem to={isAuthenticated() ? "/dashboard" : "/login"} $active={isActive('/profile')}>
          <MenuIcon>
            <FaUser />
          </MenuIcon>
          <MenuLabel>Личный кабинет</MenuLabel>
        </MenuItem>
      </MenuInner>
    </MenuWrapper>
  );
};

export default MobileBottomMenu;
